import React, { useContext, useEffect, useRef, useState } from "react";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import {
  createAssignmentRule,
  assignmentRules,
  updateFunction,
} from "../../service/Configuration";
import { RxCross2 } from "react-icons/rx";
import { fetchAgentByWorkflow, fetchFieldAgentMap, fetchFieldAgentMapProject } from "../../service/Task";
import HighlightedTextarea from "./HighlightedTextarea";
import { deleteAssignmentRule } from "../../service/Configuration";
import { Spinner } from "../../Spinner";
import translations from "../common/Translations";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import CommonButton from "../common/CommonButton";
import ReactSelector from "../common/CommonReactSelector";
import { components } from 'react-select';

const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};
const AssignmentRules = () => {
  const [selectedUserName, setSelectedUserName] = useState(0);
  const [error, setError] = useState(null);
  const [assignmentList, setAssignmentList] = useState([]);
  const {
    workflowId,
    setFieldAgentList,
    fieldAgentList,
    setSelectedUserId,
    selectedOrgId,
    activityId,
    projectId
  } = useContext(AppContext);
  const [fieldAgent, setFieldAgent] = useState([])
  const [showCriteria, setshowCriteria] = useState(false);
  const [criteria, setCriteria] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [size] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const { theme, langMode } = useContext(AppContext);
  const ruleNameRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null); // Track which dropdown is open
  const totalPages = Math.ceil(totalCount / pageSize) - 1;
  const startIndex = currentPage * pageSize;
  const endIndex = startIndex + pageSize;
  const totalItems = totalCount;

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value, 10);
    setPageSize(size);
    setCurrentPage(0);
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFieldAgentSelect = (selectedOption) => {
    // Store only the single ID directly, or null if nothing is selected
    setSelectedAgents(selectedOption ? selectedOption.value : null);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const ruleName = ruleNameRef.current.value;
    try {
      const responseData = await createAssignmentRule(
        // activityId,
        projectId,
        criteria,
        ruleName,
        isActive,
        selectedAgents
      );
      if (responseData.header.code === 600) {
        toast.success("Rule created successfully!");
        ruleNameRef.current.value = "";
        setCriteria("");
        setSelectedUserName("");
        fetchAssignmentRules();
        setSelectedAgents([]); // Reset selected checkboxes
        setDropdownOpen(false);
      } else {
        toast.error(`Error: ${responseData.body.value}`);
        ruleNameRef.current.value = "";
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(`Error submitting form: ${error.message}`);
    }
  };

  const fetchAssignmentRules = async () => {
    if (!projectId) {
      setIsLoading(false);
      return;
    }
    try {
      const data = await assignmentRules(
        false,
        // activityId,
        projectId,
        currentPage,
        pageSize,
        setAssignmentList,
        setError,
        setTotalCount
      );
    } catch (error) {
      console.error("Error fetching assignment rules:", error);
    }
  };
  useEffect(() => {
    fetchAssignmentRules();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (selectedOrgId || projectId) {
      setAssignmentList([]);
      setCurrentPage(0);
      setHasMore(true);
      fetchAssignmentRules();
    }
  }, [selectedOrgId, projectId]);

  const handlAddCriteria = () => {
    if (!projectId) {
      toast.error("Please select a workflow before adding criteria.");
      return;
    }
    setshowCriteria((prevShowCriteria) => !prevShowCriteria);
  };
  const handleUpdate = async (assignment) => {
    const updatedUserIdList = assignment.userId;
    try {
      await updateFunction(
        assignment,
        // activityId,
        projectId,
        fetchAssignmentRules,
        toast,
        setDropdownOpen,
        updatedUserIdList
      );
      setOpenDropdownIndex(null);
    } catch (error) {
      console.error("Error handling update:", error);
    }
  };
  useEffect(() => {
    const fetchFieldAgents = async () => {
      try {
        const agents = await fetchFieldAgentMap(selectedOrgId);
        setFieldAgentList(agents.body.value);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };
    fetchFieldAgents();
  }, [selectedOrgId]);

  useEffect(() => { }, [fieldAgent]);
  const handleAssigneeChange = (selectedId) => {
    setSelectedUserId(selectedId);
    const selectedAgent = fieldAgent.find(
      (agent) => agent.userId === selectedId
    );
    if (selectedAgent) {
      setSelectedUserName(selectedAgent.name);
    }
  };
  const handleToggle = (index) => {
    setIsActive((prevIsActive) => !prevIsActive);
    if (index !== undefined && index >= 0) {
      const updatedAssignments = [...assignmentList];
      updatedAssignments[index].activeStatus =
        !updatedAssignments[index].activeStatus;
      setAssignmentList(updatedAssignments);
    }
  };

  const handleRuleChange = (e, index) => {
    const updatedRules = [...assignmentList];
    updatedRules[index].rule = e.target.value;
    setAssignmentList(updatedRules);
  };

  const handleDeleteRule = async (ruleid) => {
    try {
      const response = await deleteAssignmentRule(ruleid);
      if (response.header.code === 600) {
        toast.success("Rule deleted successfully");
        setAssignmentList((prevRules) =>
          prevRules.filter((rule) => rule.id !== ruleid)
        );
      } else {
        toast.error("Failed to delete rule");
      }
    } catch (error) {
      console.error("Error deleting completion rule:", error);
      toast.error("Failed to delete rule");
    }
  };
  const handleDropdownToggle = (dropdownIndex) => {
    if (openDropdownIndex === dropdownIndex) {
      setOpenDropdownIndex(null);
    } else {
      setOpenDropdownIndex(dropdownIndex);
    }
  };


  // useEffect(() => {
  //   const handleFieldAgent = async() => {
  //     try {
  //       const result = await fetchAgentByWorkflow(activityId)
  //       setFieldAgent(result)
  //     } catch (error) {
  //       console.error("Failed to fetch field agents:", error);
  //     }
  //   }

  //   if(activityId){
  //     handleFieldAgent()
  //   }

  // }, [activityId])

  useEffect(() => {
    const handleFieldAgent = async () => {
      try {
        const result = await fetchFieldAgentMapProject(projectId)
        console.log('result', result)
        setFieldAgent(result.body.value)
      } catch (error) {
        console.error("Failed to fetch field agents:", error);
      }
    }

    if (projectId) {
      handleFieldAgent()
    }

  }, [projectId])

  return (
    <>
      <div className="xl:ps-4 lg:ps-4 md:ps-4 sm:ps-4 ps-0 p-4 flex flex-col gap-2">
        <div className="flex items-center">
          <div className="grow border-b border-dashed border-gray-400"></div>
          <span className="shrink px-1 pb-1 text-teal-600">

            <CommonButton
              onClick={handlAddCriteria}
              theme={theme}
              variant="primary"
            >
              {showCriteria ? translations[langMode].HideCriteria : translations[langMode].NewCriteria}
            </CommonButton>
          </span>
          <div className="grow border-b  border-dashed border-gray-400"></div>
          {/* <span className="text-sm px-2">    Total  :{totalCount}</span> */}
        </div>

        <div className="pb-2 flex justify-end items-center">
          <div className="text-sm text-gray-400 flex items-center gap-2">
            <label htmlFor="pageSize">{translations[langMode].rows}</label>
            <select
              id="countries_disabled"
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-2.5  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${theme === "dark"
                ? "dark-mode"
                : theme === "high-contrast"
                  ? "high-contrast"
                  : ""
                }`}
              value={pageSize}
              onChange={handlePageSizeChange}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>
        {showCriteria && (
          <form onSubmit={handleSubmit} className="xl:p-4 p-0">
            <div
              className={`bg-white border-2 border-blue-300 shadow-2xl rounded-md  py-5 p-4 ${theme === "dark"
                ? "dark-mode  "
                : theme === "high-contrast"
                  ? "high-contrast  "
                  : ""
                }`}
            >
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-semibold text-gray-900 dark:text-white">
                    {translations[langMode].rulename}
                  </label>
                  <input
                    id="areaCode"
                    ref={ruleNameRef}
                    className={`xl:max-w-60 max-w-full w-full border border-gray-300 text-gray-900 text-sm rounded-lg
                       focus:ring-blue-500 focus:border-blue-500 block  p-2.5  ${theme === "dark"
                        ? "dark-mode  "
                        : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                      }`}
                  />
                </div>
                <div>
                  <label
                    for="assignTo"
                    className="block  text-sm font-medium text-gray-900 dark:text-white"
                  ></label>
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="assignTo"
                      className="block text-sm font-semibold text-gray-900 dark:text-white"
                    >
                      {translations[langMode].assignTo}
                    </label>
                    <ReactSelector
                      value={
                        selectedAgents // selectedAgents is now a single ID (or null)
                          ? fieldAgent // Check if fieldAgent exists
                            .map((item) => ({ value: item?.userId, label: item?.userName }))
                            .find((option) => option.value === selectedAgents) // Find the option that matches the single ID
                          : null // No agent selected
                      }
                      options={(fieldAgent || [])?.map((item) => ({ value: item?.userId, label: item?.userName }))}
                      isSearchable={true}
                      height="38px !important"
                      menuPlacement="bottom"
                      menuPortalTarget={document.body}
                      components={{ Placeholder }}
                      placeholder="Field Agent"
                      onChange={handleFieldAgentSelect}
                      isClearable={true} // Allow clearing the selection for new rules
                      isMulti={false} // <--- Set this to false for single selection
                      overflow="overlay"
                      borderColor="#ffffff"
                    />

                  </div>
                </div>
                <div>
                  <label
                    htmlFor="first-name"
                    className={`block text-sm font-semibold leading-6 text-gray-900 ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {translations[langMode].activedeactive}
                  </label>
                  <div className="">
                    <input
                      type="checkbox"
                      id="toggle-switch"
                      name="toggle-switch"
                      checked={isActive}
                      onChange={handleToggle}
                      className="hidden"
                    />
                    <label
                      htmlFor="toggle-switch"
                      className={`block w-20 px-2 rounded-full border-0  py-2 text-gray-900 shadow-sm  cursor-pointer ${isActive ? "bg-blue-800" : "bg-indigo-300"
                        }`}
                    >
                      <span
                        className={`block w-10 h-5 bg-white rounded-full shadow-md transform transition-transform ${isActive ? langMode === "ar" ? "translate-x-0" : "translate-x-5" : langMode === "ar" ? "-translate-x-5" : "translate-x-0"
                          }`}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="sm:col-span-2 mt-2">
                <label
                  htmlFor="message"
                  className={`block text-sm font-semibold leading-6 text-gray-900 ${theme === "dark"
                    ? "dark-mode  "
                    : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                    }`}
                >
                  {translations[langMode].criteria}
                </label>
                <div className="">
                  <HighlightedTextarea
                    criteria={criteria}
                    setCriteria={setCriteria}
                    value={criteria}
                    onChange={(e) => setCriteria(e.target.value)}
                  />
                </div>
              </div>
              {/* <button
                type="submit"
                className="text-sm px-4 py-2 bg-blue-800 text-white rounded-md hover:bg-blue-600"
              >
                {translations[langMode].submit}
              </button> */}

              <CommonButton type="submit" variant="primary">
                {translations[langMode].submit}
              </CommonButton>
            </div>
          </form>
        )}

        {Array.isArray(assignmentList) &&
          (assignmentList.length > 0 ? (
            <ul className="xl:p-4 p-0 xl:mt-10 mt-4">
              {assignmentList.map((assignment, index) => (
                <li
                  key={assignment.id}
                  className={`mb-4 p-4 bg-white border-2 border-blue-300 shadow-2xl rounded-md ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  <RxCross2
                    className="float-right"
                    onClick={() => handleDeleteRule(assignment.id)}
                  />
                  <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="">
                      <label
                        htmlFor={`ruleName-${index}`}
                        className="block text-sm font-semibold text-gray-900 dark:text-white"
                      >
                        {translations[langMode].rulename}
                      </label>
                      <input
                        id={`ruleName-${index}`}
                        value={assignment.ruleName}
                        onChange={(e) => {
                          const updatedAssignments = [...assignmentList];
                          updatedAssignments[index].ruleName = e.target.value;
                          setAssignmentList(updatedAssignments);
                        }}
                        className={`xl:max-w-60 max-w-full w-full border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500 ${theme === "dark"
                          ? "dark-mode"
                          : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                          }`}
                      />
                    </div>
                    <div className="mb-4 flex flex-col gap-1">
                      <label
                        htmlFor={`assignTo`}
                        className="block text-sm font-semibold text-gray-900 dark:text-white"
                      >
                        {translations[langMode].assignTo}
                      </label>

                      <ReactSelector
                        options={(fieldAgent || [])?.map((item) => ({ value: item?.userId, label: item?.userName }))}
                        value={
                          // Check if assignment.userId exists and is not null/undefined
                          assignment?.userId
                            ? // Find the matching option from your fieldAgent list
                            fieldAgent
                              .map((item) => ({ value: item?.userId, label: item?.userName }))
                              .find((option) => option.value === assignment.userId) // Directly compare with assignment.userId
                            : null // If no userId, set value to null
                        }
                        isSearchable={true}
                        height="40px !important"
                        menuPlacement="bottom"
                        menuPortalTarget={document.body}
                        components={{ Placeholder }}
                        placeholder="Field Agent"
                        onChange={(selectedValue) => {
                          const updatedAssignments = [...assignmentList];
                          const currentAssignment = updatedAssignments[index];
                          // Update userId directly with the value or null if cleared
                          currentAssignment.userId = selectedValue ? selectedValue.value : null;
                          setAssignmentList(updatedAssignments);
                        }}
                        isClearable={true}
                        isMulti={false}
                        overflow="overlay"
                        borderColor="#ffffff"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor={`activeStatus-${index}`}
                        className={`block text-sm font-semibold leading-6 text-gray-900 ${theme === "dark"
                          ? "dark-mode"
                          : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                          }`}
                      >
                        {translations[langMode].activedeactive}
                      </label>
                      <div className="">
                        <input
                          type="checkbox"
                          id={`toggle-switch-${index}`}
                          name={`toggle-switch-${index}`}
                          checked={assignment.activeStatus}
                          onChange={() => handleToggle(index)}
                          className="hidden"
                        />
                        <label
                          htmlFor={`toggle-switch-${index}`}
                          className={`block w-20 px-2 rounded-full border-0 py-2 text-gray-900 shadow-sm cursor-pointer ${assignment.activeStatus
                            ? "bg-blue-800"
                            : "bg-indigo-300"
                            }`}
                        >
                          <span
                            className={`block w-10 h-5 bg-white rounded-full shadow-md transform transition-transform ${assignment.activeStatus
                              ? langMode === "ar" ? "translate-x-0" : "translate-x-5"
                              : langMode === "ar" ? "-translate-x-5" : "translate-x-0"
                              }`}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-2 mt-2">
                    <label
                      htmlFor="rule-criteria"
                      className={`block text-sm font-semibold leading-6 text-gray-900 ${theme === "dark"
                        ? "dark-mode"
                        : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                        }`}
                    >
                      {translations[langMode].criteria}
                    </label>
                    <div className="">
                      <HighlightedTextarea
                        value={assignment.rule}
                        onChange={(e) => handleRuleChange(e, index)}
                      />
                    </div>
                  </div>
                  {/* <button
                    type="button"
                    onClick={() => handleUpdate(assignment)}
                    className=" text-sm px-4 py-2 bg-blue-800 text-white rounded-md hover:bg-blue-600"
                  >
                    {translations[langMode].update}
                  </button> */}

                  <CommonButton
                    onClick={() => handleUpdate(assignment)}
                    variant="success"
                  >
                    {translations[langMode].update}
                  </CommonButton>
                </li>
              ))}
              {/* {isLoading && (
                <p>
                  Loading...
                  <Spinner />{" "}
                </p>
              )} */}
              {/* {!hasMore && <p>{translations[langMode].norule}</p>} */}
            </ul>
          ) : (
            <>
              {isLoading && (
                <p className="text-center justify-center items-center">
                  {" "}
                  {translations[langMode].norule}{" "}
                </p>
              )}
              {!hasMore && (
                <p className="text-center justify-center items-center">
                  {" "}
                  {translations[langMode].norule}
                </p>
              )}
            </>
          ))}
        <div className="flex justify-start">
          <p className="text-sm text-gray-400 flex px-5 justify-end gap-4">
            {`${startIndex}-${endIndex} of ${totalItems} items`}
            <IoIosArrowBack
              className="cursor-pointer"
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            />
            <IoIosArrowForward
              className="cursor-pointer"
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
            />
          </p>
        </div>
      </div>
    </>
  );
};
export default AssignmentRules;
